import { useEffect, useRef } from 'react'

import { useLocalParticipant } from '@livekit/components-react'

import { applyVirtualBackground } from '../utils/virtualBackgroundUtils'
import { useVirtualBackgroundSettings } from './useVirtualBackgroundSettings'

export function useVirtualBackground() {
  const { localParticipant } = useLocalParticipant()
  const appliedBackgroundRef = useRef<string | null>(null)
  const { backgroundType } = useVirtualBackgroundSettings()

  useEffect(() => {
    if (!localParticipant || appliedBackgroundRef.current === backgroundType) {
      return
    }

    // Apply the new background type
    const applyBackground = async () => {
      // Only apply if backgroundType is not null
      if (backgroundType) {
        const success = await applyVirtualBackground(localParticipant, backgroundType)
        if (success) {
          appliedBackgroundRef.current = backgroundType
        }
      }
    }

    applyBackground()
  }, [localParticipant, localParticipant.videoTrackPublications.size, backgroundType])

  return {
    appliedBackground: appliedBackgroundRef.current,
    backgroundType,
  }
}
